import { render, staticRenderFns } from "./led_recruitment_stats.vue?vue&type=template&id=6c542a58&scoped=true"
import script from "./led_recruitment_stats.vue?vue&type=script&lang=js"
export * from "./led_recruitment_stats.vue?vue&type=script&lang=js"
import style0 from "./led_recruitment_stats.vue?vue&type=style&index=0&id=6c542a58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c542a58",
  null
  
)

export default component.exports